export default __webpack_public_path__ + "static/cloudops-8071160726e93224c313f2138dd123b5.png";